/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { stringifyPredecessors } from '@gh/builder-shared-data';

import { ValueFormatterParams } from 'ag-grid-community';
import { isEmpty } from 'lodash';

export const predecessorValueFormatter = ({ value }: ValueFormatterParams) =>
  isEmpty(value) ? '' : stringifyPredecessors(value);
